<form>
  <div class="bottom">
    <div class="header">
      <div class="title">
        <h1>{{ 'questionnaire-dialog.title' | translate }}</h1>
      </div>

      <div class="close">
        <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
      </div>
    </div>

    <div class="content">

      <div class="conternt-info-left">
        <div class="content-information">
          <label>{{ 'all-trainee-assessments.table.trainee' | translate }}</label>
          <p>{{ internshipData.traineeName }} {{ internshipData.traineeLastname }}</p>
        </div>

        <div class="content-information">
          <label>{{ 'questionnaire-dialog.status-label' | translate }}</label>

          <p *ngIf="status?.compiled; else notCompiled">
            {{ 'questionnaire-dialog.status.compiled' | translate }}
          </p>

          <ng-template #notCompiled>
            <p [matTooltip]="'questionnaire-dialog.not-compiled-tooltip' | translate"
              matTooltipPosition="below">
              {{ 'questionnaire-dialog.status.not-compiled' | translate }}
            </p>
          </ng-template>
        </div>

        <div class="content-information" *ngIf="status?.dateCompilation">
          <label>{{ 'inclusion-index.pdf.date-compilation' | translate }}</label>
          <p>{{ status?.dateCompilation | date: 'dd/MM/yyyy'}}</p>
        </div>

        <div class="content-information" *ngIf="status?.totalScore">
          <label>{{ 'inclusion-index.pdf.total-score' | translate }}</label>
          <p>{{ status?.totalScore }}</p>
        </div>

      </div>

      <div class="content-info-right">
        <div class="content-information-left">
          <label>{{ 'questionnaire-dialog.email-history-label' | translate }}</label>

          <p *ngIf="emails.length > 0" class="email-history">
            <span *ngFor="let mail of emails" class="email-line">
              {{ mail.sentBy === 'sistema' ? ('questionnaire-dialog.sent-by.automatic' | translate) : ('questionnaire-dialog.sent-by.manual' | translate) }}:
              {{ mail.reminderMailSentAt | date:'dd/MM/yyyy, HH:mm a' }}
            </span>
          </p>

          <p *ngIf="emails.length === 0 && internshipData.status === 'Planned'"
            [matTooltip]="'questionnaire-dialog.not-sent-tooltip.planned' | translate"
            matTooltipPosition="below">
            {{ 'questionnaire-dialog.not-sent.planned' | translate }}
          </p>

          <p *ngIf="emails.length === 0 && internshipData.status === 'Ongoing'"
            [matTooltip]="'questionnaire-dialog.not-sent-tooltip.ongoing' | translate"
            matTooltipPosition="below">
            {{ 'questionnaire-dialog.not-sent.ongoing' | translate }}
          </p>

          <p *ngIf="emails.length === 0 && internshipData.status === 'Completed'"
            [matTooltip]="'questionnaire-dialog.not-sent-tooltip.completed' | translate"
            matTooltipPosition="below">
            {{ 'questionnaire-dialog.not-sent.completed' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div [ngClass]="{'pulsanti': true, 'single': !status?.compiled}">
      <div *ngIf="status?.compiled">
        <button type="button" (click)="viewQuestionnaire()"><mat-icon>visibility</mat-icon> {{ 'questionnaire-dialog.view-questionnaire' | translate }} </button>
      </div>

      <div *ngIf="!internshipData.questionnaireCompiled && internshipData.status === 'Completed'">
        <button type="button" (click)="sendQuestionnaireMail()"><mat-icon>send</mat-icon> {{ 'questionnaire-dialog.send-questionnaire-email' | translate }}</button>
      </div>
    </div>
  </div>
</form>
